import { Component } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';

@Block() @Component
export class ApartmentLocationStandardFinishBlock extends BaseBlock {
	get offerAppartmentsLink() {
		const offerAppartmentsLinkOrig = this.getText('offer-apartments-link');

		if (this.$route.query.predbezne && this.$route.query.csh) {
			const joiningChar = offerAppartmentsLinkOrig.includes('?') ? '&' : '?';
			return `${offerAppartmentsLinkOrig}${joiningChar}csh=${this.$route.query.csh}&predbezne=${this.$route.query.predbezne}`;
		}

		return offerAppartmentsLinkOrig;
	}
}

export default ApartmentLocationStandardFinishBlock;
